// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pH6v","question":"styles_question__1sHoQ","inputVisibleButton":"styles_inputVisibleButton__3hVhv","note":"styles_note__2PELS"};